module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	if (fox._isNewfe) {
		window.Favico = require('favico.js/favico');
	}

	fox.registerWidget('Favico', {
		configure: function(options) {
			this.currentNumber = null;

			this.registerOptions('', {
				applyOptionsOnChange: true,

				//http://lab.ejci.net/favico.js/
				favico: {
					//	Badge animation type (slide, fade, pop, popFade, none )
					animation:'slide',
					//	Badge position (up, down, left, upleft)
					position: 'down',
					//	Badge shape (circle, rectangle)
					type: 'circle',
					//	Font style (normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900)
					fontStyle: 'bold',
					//	Text font family (Arial, Verdana, Times New Roman, serif, sans-serif,...)
					fontFamily:	'sans-serif',
					//	Badge text color
					textColor:'#fff',
					//	Badge background color
					bgColor: '#d00',
				},

				handleWom: {
					optionsChange: {
						widget: '@this',
						event: 'optionsChanged',
						callback: '_handleOptionsChange'	
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function (argument) {
			this.favicoOptions = this.getOption('favico');

			this._createFavicoInstance();

			if (!this.favico.browser.supported) {
				console.warn('favicon change doesn\'t supported by browser');
			}

			this.callParent('init', arguments);
		},

		_createFavicoInstance: function () {
			if (this.favico) {
				this.favico.reset();
				delete this.favico;
			}

			this.favico = new Favico(this.favicoOptions);

			return this;
		},

		setFavicoOptions: function () {
			this.dispatchEvent('optionsChanged');

			if (fox.isObject(arguments[0])) {
				this.favicoOptions = arguments[0];

				return;
			}

			if (fox.isString(arguments[0]) && fox.isString(arguments[1])) {
				this.favicoOptions[arguments[0]] = arguments[1];

				return;
			}
		},

		getFavicoOptions: function (argument) {
			return this.favicoOptions;
		},

		_handleOptionsChange: function () {
			if (this.getOption('applyOptionsOnChange')) {
				this._createFavicoInstance();

				if (this.currentNumber) {
					this.insertNumber(this.currentNumber);
				}

				return;
			}
		},

		insertNumber: function (num) {
			this.favico.badge(num);
			this.currentNumber = num;

			return this;
		},

		reset: function (argument) {
			this.favico.reset();
			this.currentNumber = null;

			return this;
		},

		inserImage: function (img) {
			if (img.tagName.toLowerCase() !== 'img') {
				console.error('img should be an image element')

				return;
			}

			this.favico.image(img);

			return this;
		},

		inserImageFromURL: function (src) {
			if (!src.length) {
				return;
			}

			var img = document.createElement('img');
			img.src = src;

			this.inserImage(img);

			return this;
		}
	}, 'Controller');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/favico.js
// module id = 458
// module chunks = 4